import React, { useState } from "react";
import "./login.css";
import { NavLink, useNavigate } from "react-router-dom";
import { LOGO } from "../../components/image";
import { toast } from "react-toastify";
//import { createClient } from '@supabase/supabase-js'
//import { SUPABASE_API_KEY, SUPABASE_URL } from "./config/Api_url";
//const supabaseUrl = SUPABASE_URL
//const supabaseKey = SUPABASE_API_KEY
//const supabase = createClient(supabaseUrl, supabaseKey)


const Login = () => {
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    var object = {};
    data.forEach(function (value, key) {
      object[key] = value;
    });

    try {
      if (true) {
        toast.success("Login successfully !");

        navigate("/dashboard");
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      <div className="text-start ms-5 mt-5">
        <img src={LOGO} height={40} width={40} />
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "90vh" }}
      >
        <form onSubmit={handleLogin}>
          <div className="login-box">
            <div className="text-start">Login</div>

            <div className="d-flex align-items-center input-box">
              <input name="email" type="text" placeholder="Email" />
              <ion-icon name="mail-outline"></ion-icon>
            </div>

            <div className="d-flex align-items-center  input-box">
              <input name="password" type="password" placeholder="Password" />
              <ion-icon name="eye-outline"></ion-icon>
            </div>

            <div className="d-flex align-items-center gap-2">
              <input type="checkbox" />
              <label>Remember Me.</label>
            </div>

            <NavLink to={"/forgot-password"}>
              <label className="forgot-password mt-3">Forgot password ?</label>
            </NavLink>

            <button id="admin-login" name="submit" className="btn-form mt-5">
              {/* {isLoader && (
                <div className="loader">
                  <Loader height={22} width={22} color="white" />
                </div>
              )} */}
              Login
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
